import EventEmitter from "wolfy87-eventemitter";
import { ENUM_USER_ACTION_REPORT_TYPE } from "./actionTypes";

export interface Rule {
    test_id: number;
    rule_id: number;
    str_ruleid: string;
}

export interface Item {
    id: number;
    type: number;
    rule: Rule;
}

export interface SubModule {
    id: string;
    items: Array<Item>;
}

export interface PageModule {
    id: string;
    submodules: Array<SubModule>;
}

export interface Page {
    appid: string;
    pageid: string;
    modules: Array<PageModule>;
}

export enum ActionType {
    SDK = 1
}

export interface Action {
    el: Element; // page根容器
    target: Element; // 目标容器
    type: ActionType;
    immediate: boolean;
    id: string;
    content: string;
}

export interface ActionResult<T> {
    action: Action;
    result: T;
}

export interface LatestTrace {
    traceId: string;
    traceNum: number;
    traceIndex: string;
    traceDetail: {
        appid: string;
        page_id: string;
        module_id: string;
        sub_module_id: string;
        item_id: string;
        item_type: string;
        rule_id: number;
        str_ruleid: string;
    };
}

export const STORAGE_TRACE_KEY = "vt_lastest_trace_detail";

export interface ISubscriberPlugin extends EventEmitter {
    setup(): void;
}

/**
 * 处理流插件接口
 */
export interface IPipeline {
    pipe(next: IPipeline): IPipeline;
    /**
     * 输入新的事件
     * @param {InType} input
     */
    push(input): void;
}

/**
 * 页面用户行为事件订阅器
 */
export interface ISubscriber extends IPipeline {
    subscribe(): void;
}

export interface ActionItem {
    appEl?: Element;
    targetEl?: Element;
    appid: string;
    page_id: string;
    item_id?: string;
    sub_item_id?: Array<string>;
    module_id?: string;
    sub_module_id?: string;
    position_id?: string;
    test_id?: number;
    rule_id?: number;
    str_ruleid?: string;
    action_id: number;
    action_value?: number;
    action_attr?: number;
    item_type?: string;
    trigger_info?: string;
    busi_info?: string;
    to_uin?: number;
    uin?: number;
    reportType?: ENUM_USER_ACTION_REPORT_TYPE;
}

/**
 * 事件处理提取封装
 */
export interface ICompose extends IPipeline {
    /**
     * 为了兼容旧版暴露一个直接上报接口
     * @param {SDKItem} item [description]
     */
    add(item: ActionItem): void;
}

/**
 * 上报发送
 */
export type ITransport = IPipeline;

/**
 * 结果处理
 */
export type IResultUpdate = IPipeline;

/**
 * 手机QQWebView监听页面可见事件回调结果
 * @see http://mqq.oa.com/api.html#js-mqq-event-qbrowserVisibilityChange
 */
export interface QbrowserVisibilityStateEvent {
    hidden: boolean;
}
